import React from "react";

import { StyledLogoList } from "./LogoList/styled";

const LogoList = ({children}) => (<StyledLogoList>{children.map((image, index) => <div key={index}>{image}</div>)}</StyledLogoList>);

export default LogoList;